import type { PluginManifest, ModuleContext, PluginDTO } from '@gzl10/nexus-sdk'
import { toModuleDTO } from '../system/system.helpers.js'

/**
 * Converts PluginManifest to a serializable PluginDTO
 */
export function toPluginDTO(plugin: PluginManifest, ctx: ModuleContext): PluginDTO {
  const state = ctx.core.plugins.getState(plugin.name)
  return {
    name: plugin.name,
    code: plugin.code,
    label: plugin.label,
    icon: plugin.icon,
    // URL matches route: {apiPrefix}/{module.routePrefix}/:code/image
    image: plugin.image ? `/api/plugins/${plugin.code}/image` : undefined,
    category: plugin.category,
    version: plugin.version,
    description: plugin.description,
    installed: true,
    enabled: state?.enabled ?? null,
    modules: plugin.modules.map(mod => toModuleDTO(mod, ctx)),
    envVars: plugin.envVars,
    peerDependencies: plugin.peerDependencies,
    setup: plugin.setup ? {
      steps: plugin.setup.steps,
      docsUrl: plugin.setup.docsUrl,
      prerequisites: plugin.setup.prerequisites,
      caveats: plugin.setup.caveats
    } : undefined
  }
}
